<script setup lang="ts">
/**
 * The state of a one-shot screen (confirming, confirmed, refused, not found,
 * password changed) as a picture first: a large painted icon, the state in
 * game lettering, and at most one short line under it in the default slot.
 * `tone` only colours the lettering: gold for good news, plain white otherwise.
 */
import GameIcon from '../kit/GameIcon.vue';
import type { GameIconName } from '../kit/icons';

withDefaults(defineProps<{ icon: GameIconName; title: string; tone?: 'good' | 'plain' }>(), { tone: 'plain' });
</script>

<template>
  <div class="status">
    <GameIcon class="art" :name="icon" :size="96" />
    <h2 class="k-title headline" :class="{ gold: tone === 'good' }">{{ title }}</h2>
    <p v-if="$slots.default" class="line"><slot /></p>
  </div>
</template>

<style scoped>
.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.art {
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.5));
}

.headline {
  margin: 0;
  font-size: clamp(1.4rem, 6vw, 1.9rem);
  text-transform: uppercase;
}

.line {
  margin: 0;
  max-width: 30ch;
  font-family: var(--font-game-body);
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.4;
  color: #c9d6e2;
  overflow-wrap: anywhere;
}
</style>
